var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9309 15.4275L17.2884 18.3241C17.38 19.085 16.5642 19.6166 15.9134 19.2225L12.7417 17.3341C12.5217 17.2058 12.4667 16.9308 12.5859 16.7108C13.0442 15.8675 13.2917 14.9141 13.2917 13.9608C13.2917 10.6058 10.4134 7.87415 6.87502 7.87415C6.15086 7.87415 5.44502 7.98415 4.78502 8.20415C4.44586 8.31415 4.11586 8.00248 4.19836 7.65415C5.03252 4.31748 8.24086 1.83331 12.0725 1.83331C16.5459 1.83331 20.1667 5.21581 20.1667 9.38665C20.1667 11.8616 18.8925 14.0525 16.9309 15.4275Z",
    fill: "#0B101C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9173 13.9608C11.9173 15.0516 11.514 16.06 10.8357 16.8575C9.92815 17.9575 8.48898 18.6633 6.87565 18.6633L4.48315 20.0841C4.07982 20.3316 3.56648 19.9925 3.62148 19.525L3.85065 17.7191C2.62232 16.8666 1.83398 15.5008 1.83398 13.9608C1.83398 12.3475 2.69565 10.9266 4.01565 10.0833C4.83148 9.55165 5.81232 9.24915 6.87565 9.24915C9.66232 9.24915 11.9173 11.3575 11.9173 13.9608Z",
    fill: "#0B101C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.9c97690db406c77cde9e164cbedc394c.svg";
export { ForwardRef as ReactComponent };